import { render, staticRenderFns } from "./accreditor.vue?vue&type=template&id=585e2584&"
import script from "./accreditor.vue?vue&type=script&lang=js&"
export * from "./accreditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports